module.exports = __webpack_public_path__ + "static/sport/game-1.06daf49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/game-1.png
// module id = lheM
// module chunks = 0